import {Component} from "preact"
import ToolbarButton from "../../../../../common/toolbar-button";
import ConfigService from "../../../../../../services/ConfigService";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import Toolbar from "../../../../../layout/toolbar";
import ScrollableSection from "../../../../../layout/scrollable-section";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import Text from "../../../../../common/text";
import {translate, TranslateService} from "../../../../../../services/TranslateService";
import SectionComponent from "../../../../../layout/section-component";
import {createEvent} from "../../../../../../utilities/create-event";
import ArrowLeftIcon from "mdi-preact/ArrowLeftIcon";
import style from "./styles.scss";
import BookmarkOutlineIcon from "mdi-preact/BookmarkOutlineIcon";
import OpenInNewIcon from "mdi-preact/OpenInNewIcon";

export default class ManualList extends Component {

    static defaultProps = {
        onNavigate: () => {}
    };

    render(props, state, context) {
        const hasManuals = Array.isArray(ConfigService.manuals()) && ConfigService.manuals().length;
        if (!hasManuals) {
            setTimeout(this.backToMain);
            return null;
        }

        return (
            <VerticalUiContainer>
                <Toolbar class={style.toolbar}>
                    <SectionComponent style={{flexGrow: 0}}>
                        <ToolbarButton onClick={this.backToMain} title={translate('action.back')}><ArrowLeftIcon/></ToolbarButton>
                    </SectionComponent>
                    <div className={style.iconButton}><BookmarkOutlineIcon/></div>
                    <ToolbarTitle><Text text={'manuals_dropdown_title'}/></ToolbarTitle>
                </Toolbar>
                <ScrollableSection>
                    {ConfigService.manuals().map((item, index) => (
                        <a class={style.manualLink} href={TranslateService.translatable(item.url)} target="_blank">
                            <div class={style.number}>{index + 1}</div>
                            {TranslateService.translatable(item.title)}
                            <OpenInNewIcon class={style.linkIcon}/>
                        </a>
                    ))}
                </ScrollableSection>
            </VerticalUiContainer>
        );
    }

    backToMain = () => {
        this.props.onNavigate('main');
    };

    navigateToManual = (url) => {
        this.base.dispatchEvent(createEvent('closeDropdown', {bubbles:true}));
        ConfigService.navigateFunction(url);
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/help-desk/manual-list/index.js